import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Wallet } from "lucide-react";
import { api, formatXAF } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";

export const useWallet = () =>
  useQuery({ queryKey: ["wallet"], queryFn: async () => (await api.get("/wallet")).data, staleTime: 10_000 });

export const BalanceChip = () => {
  const { data } = useWallet();
  const { lang } = useI18n();
  return (
    <Link
      to="/wallet"
      className="flex h-10 items-center gap-2 whitespace-nowrap rounded-full border border-emerald-500/30 bg-emerald-500/10 px-2.5 font-mono text-xs font-semibold text-emerald-300 transition-colors hover:bg-emerald-500/20 sm:px-3 sm:text-sm"
      data-testid="header-balance-chip"
    >
      <Wallet className="h-4 w-4" />
      {formatXAF(data?.available ?? 0, lang)}
    </Link>
  );
};
